<div class="ng2-tag-input">
  <div class="ng2-tags-container">
    <span class="tag" *ngFor="let chip of chips; let i = index">
      <span>{{ chip.display }}</span>
      <button type="button" class="tag-remove" [disabled]="disabled" (click)="remove(i)" aria-label="Remove">&times;</button>
    </span>
    <input type="email" [(ngModel)]="text" [ngModelOptions]="{ standalone: true }" [disabled]="disabled"
      [placeholder]="chips.length === 0 ? secondaryPlaceholder : placeholder"
      (keydown.enter)="onEnter($event)" (keydown.backspace)="onBackspace()" (blur)="onBlur()">
  </div>
  <div class="error-messages" *ngFor="let error of errors">
    <small class="text-danger">{{ error }}</small>
  </div>
</div>
